import { storage } from "@/firebase"

const uploadImg = async (idContract, file) => {
    try {
        const imgNameSaved = new Date().getTime()
        const pathSaved = `contracts/${idContract}/${imgNameSaved}`
        const storageWS_REF = storage.ref(pathSaved)
        var task = storageWS_REF.put(file);
        await new Promise((resolve, reject) => {
            task.on('state_changed',
                function progress(snapshot) {
                    var percentage = snapshot.bytesTransferred / snapshot.totalBytes * 100;
                },
                function error(err) {
                    console.error(`uploadImg - ${err}`)
                    reject(err)
                },
                function complete() {
                    var downloadURL = task.snapshot.downloadURL;
                    resolve("Download Complet")
                }
            );
        })
        return pathSaved
    } catch (error) {
        console.error("uploadImg ",error)
    }
}
const uploadFile = async (idContract, file, addTimestamp = true) => {
    try {
        const allowedTypes = ["application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
        if (!allowedTypes.includes(file.type))  throw new Error("Somente arquivos PDF ou DOCX são permitidos.");

        const fileName = addTimestamp ? `${new Date().getTime()}_${file.name}` : file.name;
        const filePath = `contracts/${idContract}/${fileName}`;

        const storageRef = storage.ref(filePath);

        const uploadTask = storageRef.put(file);

        await new Promise((resolve, reject) => {
            uploadTask.on(
                "state_changed",
                function progress(snapshot) {
                    const percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                },
                function error(err) {
                    reject(err);
                },
                function complete() {
                    resolve();
                }
            );
        });
        // const downloadURL = await storageRef.getDownloadURL();
        return filePath;
    } catch (error) {
        console.error("Erro ao fazer upload do arquivo:", error.message);
        throw error;
    }
}
const downloadImg = async (path) => {
    try {
        const fileRef = storage.ref(path);
        const downloadURL = await fileRef.getDownloadURL();
        const response = await fetch(downloadURL);
        const blob = await response.blob();
        return blob;
    } catch (error) {
        console.error(error)
    }
}
const deleteImg = async (path) => {
    try{
        await storage.ref(path).delete()
    }catch(err){
        console.error(`Error - deleteImg ${err}`)
    }
}

const listFiles = async (path) => {
    try {
        const folderRef = storage.ref(path);
        const result = await folderRef.listAll();
        
        const files = await Promise.all(
            result.items.map(async (itemRef) => {
                const url = await itemRef.getDownloadURL();
                return {
                    name: itemRef.name,
                    url: url,
                    path: itemRef.fullPath
                };
            })
        );
        
        return files;
    } catch (error) {
        console.error("Error listing files:", error);
        throw error;
    }
}

export default {
    uploadImg,
    deleteImg,
    uploadFile,
    downloadImg,
    listFiles
}